import React, { Fragment } from 'react';
import { HomeIcon, ChevronRightIcon } from 'lucide-react';
interface BreadcrumbItem {
  label: string;
  href?: string;
}
interface PageHeroBreadcrumbProps {
  breadcrumbs: BreadcrumbItem[];
  title: string;
  description?: string;
  showTitle?: boolean;
  showDescription?: boolean;
  hideBreadcrumbOnMobile?: boolean;
}
export function PageHeroBreadcrumb({
  breadcrumbs,
  title,
  description,
  showTitle = true,
  showDescription = true,
  hideBreadcrumbOnMobile = true
}: PageHeroBreadcrumbProps) {
  return <div className="hidden border-b border-gray-100 bg-white md:block" data-id="element-2463" data-mp="ptwoj36yn9ur">
      <div className="container mx-auto px-4 pt-4 pb-6 md:pt-8 md:pb-8" data-id="element-2464" data-mp="urorqtd22ie9">
        {/* Breadcrumb Navigation with Horizontal Scroll */}
        <div className={`${hideBreadcrumbOnMobile ? 'hidden md:block' : ''} overflow-x-auto scrollbar-hide -mx-4 px-4 mb-3`} data-id="element-2465" data-mp="zsw0ovqxpnmi">
          <nav className="flex items-center text-[13px] text-gray-500 whitespace-nowrap min-w-max" aria-label="Breadcrumb" data-id="element-2466" data-mp="269pubr8lhfoy">
            {breadcrumbs.map((item, index) => {
            const isLast = index === breadcrumbs.length - 1;
            return <Fragment key={index} data-id="element-2467" data-mp="2rx0m3oxk4tp" data-mpi={index}>
                  {index > 0 && <ChevronRightIcon className="w-3.5 h-3.5 mx-2 text-gray-400 flex-shrink-0" aria-hidden="true" data-id="element-2468" data-mp="3uw8xcamahjdb" />}
                  {item.href && !isLast ? <a href={item.href} className="hover:text-[#1E2B55] transition-colors flex items-center flex-shrink-0" data-id="element-2469" data-mp="3g960m65sjer1">
                      {index === 0 && <HomeIcon className="w-3.5 h-3.5 mr-1.5 flex-shrink-0" data-id="element-2470" data-mp="379945id5tblf" />}
                      <span data-id="element-2471" data-mp="327tjhrew973k">{item.label}</span>
                    </a> : <span className={`flex items-center flex-shrink-0 ${isLast ? 'text-[#0f172a] font-medium' : ''}`} aria-current={isLast ? 'page' : undefined} data-id="element-2472" data-mp="2xb36jcydyrmd">
                      {index === 0 && <HomeIcon className="w-3.5 h-3.5 mr-1.5 flex-shrink-0" data-id="element-2473" data-mp="2doi31bvfsn0f" />}
                      <span data-id="element-2474" data-mp="2imtbpj9zwrh2">{item.label}</span>
                    </span>}
                </Fragment>;
          })}
          </nav>
        </div>
        {/* Page Title - Conditionally rendered */}
        {showTitle && <h1 className="text-2xl md:text-[32px] font-bold text-[#0f172a] mb-2 tracking-tight" data-id="element-2475" data-mp="3bb8nlwxtyto6">
            {title}
          </h1>}
        {/* Description - Conditionally rendered */}
        {showDescription && description && <p className="text-sm md:text-base text-gray-600 leading-relaxed max-w-4xl" data-id="element-2476" data-mp="3pc1kgoblu0ug">
            {description}
          </p>}
      </div>
    </div>;
}